const List = () => import('./List.vue')
const Edit = () => import('./Edit.vue')
const Self = () => import('./Self.vue')
const Show = () => import('./Show.vue')

export default { List, Edit, Self, Show }
